import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Page Not Found | Krithish Scientific Company", "The page you are looking for does not exist.");
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center bg-slate-50 px-6 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-safety">Error 404</p>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-slate-900">Page not found</h1>
      <p className="mt-3 max-w-md text-sm text-slate-500">
        The page you're looking for doesn't exist or has moved. Try the catalog instead.
      </p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-lg bg-safety px-6 py-3 text-sm font-semibold text-white transition hover:bg-safety-dark">
        Back to Home
      </Link>
    </div>
  );
}
